<template>
  <b-modal :id="id" title="Crear sucursal" :ok-disabled="loading" @ok="handleOk">
    <!-- nombre, direccion, comuna, ciudad -->
    <b-form-group label="Sucursal" label-for="nombre" description="Nombre de la sucursal">
      <b-form-input
        id="nombre"
        v-model="$v.form.nombre.$model"
        :state="$v.form.nombre.$dirty ? !$v.form.nombre.$error : null"
        placeholder="Nombre"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Dirección" label-for="direccion" description="Dirección de la sucursal">
      <b-form-input
        id="direccion"
        v-model="$v.form.direccion.$model"
        :state="$v.form.direccion.$dirty ? !$v.form.direccion.$error : null"
        placeholder="Dirección"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Comuna" label-for="comuna" description="Comuna de la sucursal">
      <b-form-input
        id="comuna"
        v-model="$v.form.comuna.$model"
        :state="$v.form.comuna.$dirty ? !$v.form.comuna.$error : null"
        placeholder="Comuna"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Ciudad" label-for="ciudad" description="Ciudad de la sucursal">
      <b-form-input
        id="ciudad"
        v-model="$v.form.ciudad.$model"
        :state="$v.form.ciudad.$dirty ? !$v.form.ciudad.$error : null"
        placeholder="Ciudad"
      ></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "CreateSucursal",
  props: {
    id: {
      type: String,
      default: "modal-create-sucursal"
    },
    companyId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      form: {
        nombre: "",
        direccion: "",
        comuna: "",
        ciudad: ""
      },
      loading: false
    };
  },
  validations: {
    form: {
      nombre: {
        required
      },
      direccion: {
        required
      },
      comuna: {
        required
      },
      ciudad: {
        required
      }
    }
  },
  methods: {
    async handleOk(evt) {
      this.$v.$touch();
      evt.preventDefault();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      const payload = {
        name: this.form.nombre,
        address: this.form.direccion,
        township: this.form.comuna,
        city: this.form.ciudad,
        company: this.companyId
      };
      try {
        const response = await this.$axios.post("/api/v1/office/", payload);
        this.$swal({
          title: "Éxito",
          text: "La sucursal se ha creado correctamente",
          type: "success",
          confirmButtonText: "Aceptar"
        });
        this.$emit("success", response.data);
        this.$bvModal.hide(this.id);
      } catch (err) {
        console.log(err);
        this.$swal("Error", err.response.data.detail, "error");
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
